var template = `
  <style>
:host {
  background: linear-gradient(to bottom, #DDD, #CCC);
  display: block;
}

@keyframes ants {
  from {
    stroke-dashoffset: 12.5;
  }

  to {
    stroke-dashoffset: 0;
  }
}

button.play {
  width: 100%;
  aspect-ratio: 1;
  appearance: none;
  border: none;
  border-radius: 100%;
  background: linear-gradient(to bottom, white, #E8E8E8);
  box-shadow: 0 16px 16px -8px #0003;
  display: block;
  margin: 1em auto;
  padding: 0;

  & svg {
    display: block;
    width: 100%;
    overflow: visible;
  }

  .circle {
    stroke: black;
    stroke-width: .2;
    fill: none;
    stroke-dasharray: 12.5 12.5;
    stroke-linecap: round;
  }

  .outline {
    stroke: #AAA;
    stroke-width: .2;
    fill: none;
  }

  &.loading .circle {
    stroke-dasharray: 1 1;
    animation: ants 3s infinite;
  }

  .icon.pause {
    visibility: hidden;
    stroke-width: .5;
    stroke: black;
    fill: none;
  }

  &[aria-pressed="true"] {
    .icon.pause {
      visibility: visible;
    }

    .icon.play {
      visibility: hidden;
    }
  }
}

  </style>
  Listen to this story, as broadcast on WBEZ:

  <button class="play" aria-pressed="false" aria-label="Play audio">
    <svg viewBox="0 0 4 4">
      <path class="icon play" d="M1.5,1 L3,2 L1.5,3 Z" />
      <path class="icon pause" d="M1.5,1 v2 M2.5,1 v2" />
      <path class="outline" d="M2,0 A2,2 0 1 1 1.999,0 Z" />
      <path class="circle" d="M2,0 A2,2 0 1 1 1.999,0 Z" />
    </svg>
  </button>

  <audio hidden></audio>

`

class AudioPlayer extends HTMLElement {
  static observedAttributes = ["src"];

  constructor() {
    super();
    var root = this.attachShadow({ mode: "open" });
    root.innerHTML = template;
    this.elements = {
      progress: root.querySelector(".circle"),
      button: root.querySelector("button"),
      audio: root.querySelector("audio")
    }

    this.elements.button.addEventListener("click", this);
    this.elements.audio.addEventListener("timeupdate", this);
    this.elements.audio.addEventListener("play", this);
    this.elements.audio.addEventListener("paused", this);
    this.elements.audio.addEventListener("loadstart", this);
    this.elements.audio.addEventListener("canplay", this);
    this.elements.audio.playbackRate = 10;
  }

  attributeChangedCallback(attr, was, value) {
    this.elements.audio.src = value;
  }

  handleEvent(e) {
    var { button, audio, progress } = this.elements;

    switch (e.type) {
      case "click":
        if (audio.paused) {
          audio.play();
          button.setAttribute("aria-pressed", "true");
        } else {
          audio.pause();
          button.setAttribute("aria-pressed", "false");
        }
        break;

      case "loadstart":
        button.classList.add("loading");
        break;

      case "canplay":
        button.classList.remove("loading");

      default:
        // audio.playbackRate = 10;
        var time = audio.currentTime;
        var duration = audio.duration;
        var ratio = time == 0 ? 1 : time / duration;
        var length = 12.5;//progress.getTotalLength();
        var offset = length - length * ratio;
        // console.log(length, offset);
        // progress.style.strokeDasharray = `${length} ${length}`;
        progress.style.strokeDashoffset = offset;
    }
  }
}

window.customElements.define("audio-player", AudioPlayer);